module.exports = __webpack_public_path__ + "static/img/Body-15.fb9ef3ac.jpg";